import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";

import Dashboard from "./views/Dashboard";
import Products from "./views/Products";
import Orders from "./views/Orders";
import Reports from "./views/Reports";
import Login from "./views/Login";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => setIsAuthenticated(false); // Maneja logout

  // Si no está autenticado, mostrar login
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="flex min-h-screen bg-gray-900">
        {/* Sidebar escritorio */}
        <div className="hidden md:flex">
          <Sidebar />
        </div>

        {/* Contenido principal */}
        <div className="flex-1 flex flex-col">
          {/* Header con toggle y logout */}
          <Header toggleSidebar={toggleSidebar} onLogout={handleLogout} />

          {/* Sidebar modal móvil */}
          {isSidebarOpen && (
            <div className="fixed inset-0 z-50 flex md:hidden">
              <div className="absolute inset-0 bg-black/50" onClick={toggleSidebar}></div>
              <aside className="relative w-64 bg-gray-900 border-r border-gray-800 p-6">
                <Sidebar />
              </aside>
            </div>
          )}

          <main className="p-8 flex-1 overflow-auto">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/products" element={<Products />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/reports" element={<Reports />} />
              {/* Redirige cualquier ruta desconocida al dashboard */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
